import React, { useState, useContext } from 'react';

import { cloneDeep } from '../../../utils/lodash';

import { makeStyles } from '@mui/styles';
import { ButtonBase, Tooltip } from '@mui/material';

import { EventsContext } from '../EventsContext';
import Filters from '../../../common/Filters';
import Macros from '../../../common/Macros';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import LoaderNew from '../../../common/LoaderNew';

import EventsStyles from '../EventsStyles';
import CommonStyles from '../../../common/CommonStyles';
import ActionConfirmation from '../../../common/ActionConfirmation';

const useStyles = makeStyles({
  ...CommonStyles,
  ...EventsStyles,
});

const EventByGraphTrigger = (props) => {
  const { nodesData, updateEvent, deleteEvent, addNodeToNodesData } = useContext(EventsContext);
  const [saveLoading, setSaveLoading] = useState(false);
  const [editable, setEditable] = useState(props.editable);
  const [event, setEvent] = useState(cloneDeep(props.event));
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const classes = useStyles({
    editable,
  });

  const deleteJelModal = {
    contentText: 'Delete',
    contentBoldText: `${event.id} ${event.type} event?`,
    open: showDeleteModal,
  };

  const eventIsUnsaved = event && !event.id;

  const setGraphTriggerAncestorToParentState = (graphTriggerAncestor) => {
    setEvent({
      ...event,
      trigger: {
        ...event.trigger,
        ancestor: graphTriggerAncestor ? graphTriggerAncestor.id : null,
      }
    });
  };

  const setFiltersToState = (filters) => {
    setEvent({
      ...event,
      trigger: {
        ...event.trigger,
        trpls: filters,
      }
    });
  };

  const setFunctionPerfValues = (type, value) => {
    setEvent(cloneDeep({
      ...event,
      macro: {
        ...event.macro,
        [type]: value,
      }
    }));
  };

  const saveGraphTriggerEvent = () => {
    setSaveLoading(true);
    updateEvent(null, event.type, event, (updatedEvent) => {
      setEvent(cloneDeep(updatedEvent));
      setEditable(false);
      setSaveLoading(false);
    });
  }

  const disabledSaveBtn = !event.trigger.ancestor
  || (event.trigger.trpls && !event.trigger.trpls.length)
  || (event.trigger.trpls.length && event.trigger.trpls[0].pids_chain && !event.trigger.trpls[0].pids_chain.length);

  return (
    <React.Fragment>
      <ActionConfirmation
        modalData={deleteJelModal}
        acceptHandler={() => {
          deleteEvent(null, event.type, event.id);
          setShowDeleteModal(false);
          setEditable(false);
        }}
        onClose={() => setShowDeleteModal(false)}
      />

      <div className={classes.row} style={{background: editable ? '#DBD6E5' : '#FBFBFB'}}>
        <div className={classes.rowContent}>
          <div style={{ width: '20px', marginRight: '10px' }}>
              <span className={classes.subId}>{event.id}</span>
          </div>
          <div style={{ minWidth: '40%' }} className={`${classes.arrow} ${classes.fillAvailable}`}>
            <Filters
              defaultBg={true}
              ancestor={event.trigger.ancestor}
              callbacks={{
                setGraphTriggerAncestorToParentState: setGraphTriggerAncestorToParentState,
                setFiltersToParentState: setFiltersToState,
                onFiltersSearchNodeCb: addNodeToNodesData,
              }}
              useChain
              isEvent
              nodes={nodesData}
              graphTriggerAncestor={nodesData[event.trigger.ancestor]}
              mode={editable ? 'edit' : 'show'}
              initialFilters={event.trigger.trpls}
            />
          </div>

          <div className={`${classes.ml20} ${classes.macroBlock}`}>
            <Macros
              showCode={true}
              editable={editable}
              macro={event.macro}
              oldMacro={(props.event.macro && props.event.macro.code) || ''}
              functionVal={(event.macro && event.macro.code) || ''}
              scriptType={(event.macro && event.macro.script_type) || ''}
              returnType={(event.macro && event.macro.return_type) || ''}
              setFunctionPerfValues={setFunctionPerfValues}
            />
          </div>

          <div className={`${classes.editRowCol} ${classes.ml20}`}>
            {!editable ? (
              <Tooltip
                title="Edit"
                placement="top"
                classes={{
                  tooltip: classes.muiTooltip,
                }}
              >
                <EditIcon
                  onClick={() => {
                    setEditable(true);
                  }}
                />
              </Tooltip>
            ) : null}
          </div>
        </div>

        {editable ? (
          <div className={classes.rowButtonsContainer}>
            {!eventIsUnsaved ? (
              <ButtonBase
                className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr10}`}
                onClick={() => {
                  setShowDeleteModal(true);
                }}
              >
                <span>Delete</span>

                <DeleteIcon className={classes.deleteRowIcon} />
              </ButtonBase>
            ) : <div />}

            <div className={classes.alignCenter}>
              <ButtonBase
                className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr20}`}
                onClick={() => {
                  setEditable(false);
                  setEvent(props.event);

                  // unsaved events shouldn't be in events list after editing
                  if (eventIsUnsaved) {
                    deleteEvent(null, event.type, event.draft_id);
                  }
                }}
              >
                Cancel
              </ButtonBase>
              <ButtonBase
                disabled={disabledSaveBtn}
                className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnNormal}`}
                style={{
                  opacity: disabledSaveBtn ? 0.5 : 1
                }}
                onClick={() => {
                  // if (event.macro) { //uncomment when back will be ready to receive no mucro - to delete it
                  //   for (let property in event.macro) {
                  //     if (!event.macro[property].length) delete event.macro[property];
                  //   }
                  // }
                  // if (Object.keys(event.macro).length === 0) delete event.macro;
                  saveGraphTriggerEvent();
                }}
              >
                {saveLoading ? <LoaderNew /> : 'Save'}
              </ButtonBase>
            </div>
          </div>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default EventByGraphTrigger;
